import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-priority-request-form',
  templateUrl: './priority-request-form.component.html',
  styleUrls: ['./priority-request-form.component.scss']
})
export class PriorityRequestFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
